export const navLogo = {
    img: require('../../images/logo.png'),
    alt: 'Logo',
 
  }